import React, {useEffect} from 'react';
import {Divider} from 'wix-ui-tpa/cssVars';
import {classes} from './CustomerInputSection.st.css';
import {useBooleanStyleForAnyBreakpoint} from '../../../../../common/useBooleanStyleForAnyBreakpoint';
import {useControllerProps} from '../../../../../domain/controllers/ControllerContext';
import {Coupon} from '../../../../../common/components/Coupon/Coupon';
import stylesParams from '../../../stylesParams';
import settingsParams from '../../../settingsParams';
import {BuyerNote} from '../../../../../common/components/BuyerNote/BuyerNote';
import {useSettingsWithDefaults} from '../../../../../hooks/useSettingsWithDefaults';

export enum CustomerInputSectionDataHooks {
  root = 'CustomerInputSectionDataHooks.root',
  divider = 'CustomerInputSectionDataHooks.divider',
}

export const CustomerInputSection = () => {
  const {
    sideCartCouponAndNote,
    sideCartNote,
    sideCartElementsVisibilityInCss,
    sendBIForPromoCodeAndNoteDisplay,
    reportPromoCodePresented,
    reportBuyerNotePresented,
  } = useControllerProps().cartStore;
  const {getBooleanStyle} = useBooleanStyleForAnyBreakpoint();
  const {getSettingsWithDefaults} = useSettingsWithDefaults();

  const showPromoCodeBySettings = getBooleanStyle(
    stylesParams.CUSTOMER_INPUTS_PROMO_CODE_VISIBILITY,
    sideCartElementsVisibilityInCss
  );

  const showBuyerNoteBySettings = getBooleanStyle(
    stylesParams.CUSTOMER_INPUTS_NOTE_VISIBILITY,
    sideCartElementsVisibilityInCss
  );

  const shouldRenderCoupon = sideCartCouponAndNote && showPromoCodeBySettings;
  const shouldRenderBuyerNote = sideCartNote && showBuyerNoteBySettings;
  const shouldRenderSection = shouldRenderCoupon || shouldRenderBuyerNote;

  useEffect(() => {
    if (sendBIForPromoCodeAndNoteDisplay) {
      reportPromoCodePresented(shouldRenderCoupon);
      reportBuyerNotePresented(shouldRenderBuyerNote);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldRenderCoupon, shouldRenderBuyerNote]);

  return shouldRenderSection ? (
    <div data-hook={CustomerInputSectionDataHooks.root}>
      <Divider className={classes.divider} data-hook={CustomerInputSectionDataHooks.divider} />
      <div className={classes.linksWrapper}>
        {shouldRenderCoupon && (
          <Coupon
            textButtonSettingKey={settingsParams.SIDE_CART_ADD_PROMO_CODE_LINK}
            placeholderTranslationKey={getSettingsWithDefaults(settingsParams.SIDE_CART_PROMO_CODE_INPUT_PLACEHOLDER)}
            applyButtonTranslationKey={'sideCart.couponApplyButton.label'}
          />
        )}
        {shouldRenderBuyerNote && (
          <BuyerNote
            buttonCaptionSettingKey={settingsParams.SIDE_CART_ADD_NOTE_LINK}
            buttonPlaceholderSettingKey={settingsParams.SIDE_CART_INSTRUCTIONS_TEXT}
          />
        )}
      </div>
    </div>
  ) : null;
};
